/**
 * Simple Event Bus for Cross-Component Communication
 * Use for events that don't need state management
 */

class EventBus {
  constructor() {
    this.events = {};
  }

  // Subscribe to an event
  on(eventName, callback) {
    if (!this.events[eventName]) {
      this.events[eventName] = [];
    }
    this.events[eventName].push(callback);

    // Return unsubscribe function
    return () => {
      this.events[eventName] = this.events[eventName].filter(cb => cb !== callback);
    };
  }

  // Emit an event
  emit(eventName, data) {
    if (this.events[eventName]) {
      this.events[eventName].forEach(callback => {
        try {
          callback(data);
        } catch (error) {
          console.error(`Error in event handler for ${eventName}:`, error);
        }
      });
    }
  }

  // Remove all listeners for an event
  off(eventName) {
    delete this.events[eventName];
  }
}

// Export singleton instance
const eventBus = new EventBus();

// Event constants
export const EVENTS = {
  FAILED_ORDER_CREATED: 'failedOrderCreated',
  ORDER_PLACED_SUCCESS: 'orderPlacedSuccess',
  POSITION_UPDATED: 'positionUpdated',
};

export default eventBus;
